import { render, staticRenderFns } from "./AssetBook.vue?vue&type=template&id=0c411196&scoped=true&"
import script from "./AssetBook.vue?vue&type=script&lang=ts&"
export * from "./AssetBook.vue?vue&type=script&lang=ts&"
import style0 from "./AssetBook.vue?vue&type=style&index=0&id=0c411196&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c411196",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c411196')) {
      api.createRecord('0c411196', component.options)
    } else {
      api.reload('0c411196', component.options)
    }
    module.hot.accept("./AssetBook.vue?vue&type=template&id=0c411196&scoped=true&", function () {
      api.rerender('0c411196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Setup/AssetBook.vue"
export default component.exports